/*eslint-env jquery*/
import React, { Component } from 'react'
import { toastr } from 'react-redux-toastr'
import Loading from '../../Shared/Loading'
import { taskOperationsService } from '../../../_services/taskOperations.service'
import { GoPlus } from 'react-icons/go'
import ErrorPopUp from '../../Shared/ErrorPopUp'
import MeasurementTypeDoubleBox from '../../Shared/MeasurementTypeDoubleBox'
import AsyncBrandSelect from '../../Shared/AsyncBrandSelect'
import AsyncProductSelect from '../../Shared/AsyncProductSelect'
import QtyInputPlusMinus from '../../Shared/QtyInputPlusMinus'
import QtyInput from '../../Shared/QtyInput'

import { Formik, FieldArray, Field, ErrorMessage } from 'formik'
import * as Yup from 'yup'

import { AiOutlineLoading, AiOutlineSave } from 'react-icons/ai'

class ChangeProductsForm extends Component {
  constructor(props, context) {
    super(props, context)

    this.state = {
      loading: false,

      data: {
        item: this.props.item || {},
        newItem: {}
      }
    }
    // console.log(this.props.item);
  }

  handleSubmit = (values, setSubmitting) => {
    // this.setState({ loading: true });
    // values["taskType"] = this.state.taskType;
    // console.log(values);

    // console.log(JSON.stringify(values));

    let dto = {}
    dto['productId'] = values.item.productId
    dto['taskOperationId'] = values.item.taskOperationId
    dto['newProductId'] = values.newItem.productId
    console.log(dto)
    console.log(JSON.stringify(dto))

    taskOperationsService
      .replaceProduct(JSON.stringify(dto))
      .then(res => {
        console.log(res)

        toastr.success('جایگزینی مواد اولیه انجام شد')
        setSubmitting(false)

        this.props.onSubmit()
      })
      .catch(error => {
        setSubmitting(false)
      })
  }

  handleError(error) {
    this.setState({ loading: false })
    // toastr.warning('مشکلی پیش آمد', error);
  }

  // componentWillReceiveProps(nextProps) {
  //   console.log(nextProps);

  //   if (nextProps.itemsInitialValues) {

  //     let itm = this.props.item
  //     let initialItm = nextProps.itemsInitialValues.filter(el => el.productId === itm.productId)[0]
  //     console.log(nextProps.itemsInitialValues);
  //     console.log(itm);

  //     if (initialItm) {
  //       itm["initialQuantity"] = initialItm.quantity
  //       let data_ = this.state.data
  //       data_["item"] = initialItm
  //       this.setState({ data: data_ })
  //       console.log(data_);

  //     }

  //   }
  // }

  render() {
    const { data, taskType } = this.state

    // const item = Yup.object().shape({
    //   categoryId: Yup.string().trim().nullable().required('دسته بندی'),
    //   brandId: Yup.string().trim().nullable().required('برند'),
    //   productId: Yup.string().trim().nullable().required('محصول')
    // });

    const ValidationSchema = Yup.object().shape({
      newItem: Yup.object().shape({
        productId: Yup.string()
          .trim()
          .nullable()
          .required('محصول')
      })
      // categoryId: Yup.string().trim().nullable().required('دسته بندی'),
      // categoryId: Yup.string().trim().nullable().required('دسته بندی'),
      // brandId: Yup.string().trim().nullable().required('برند'),
      // productId: Yup.string().trim().nullable().required('محصول'),
      // quantity: Yup.string().trim().required('مقدار محصول'),
      // items: Yup.array().of(item).min(taskType === 1 ? 3 : 1, 'تمامی اطلاعات مواد اولیه').required('تمامی اطلاعات مواد اولیه'),
    })
    return (
      <Formik
        enableReinitialize
        initialValues={data}
        onSubmit={(values, { setSubmitting }) => {
          this.handleSubmit(values, setSubmitting)
        }}
        validationSchema={ValidationSchema}>
        {props => {
          const {
            values,
            touched,
            errors,
            setFieldValue,
            setFieldTouched,
            isSubmitting,
            handleChange,
            handleBlur,
            handleSubmit,
            validateForm
          } = props
          return (
            <div>
              <div className="row" style={{ position: 'relative' }}>
                <form onSubmit={handleSubmit}>
                  {values && values.item && values.item.product && (
                    <fieldset className="fieldset">
                      <legend>کالای فعلی</legend>
                      <table
                        className="table validator-table"
                        style={{ marginBottom: 5 }}>
                        <thead>
                          <tr>
                            <th className="text-center">دسته بندی</th>
                            <th className="text-center">برند</th>
                            <th className="text-center">نام کالا</th>
                            <th className="text-center">کد کالا</th>
                            {/* <th className="text-center">مقدار اولیه</th>
                            <th className="text-center">مصرف اضافی</th>
                            <th className="text-center">ضایعات</th>
                            <th className="text-center">مقدار باقیمانده</th> */}
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>{values.item.product.category.name}</td>
                            <td>{values.item.product.brand.name}</td>
                            <td>{values.item.product.name}</td>
                            <td>{values.item.product.extraCode}</td>
                            {/* <td>
                              <MeasurementTypeDoubleBox
                                product={values.item.product}
                                value={values.item.firstQuantity}
                                onlySub={values.item.product.subMeasurementType !== null ? true : false}
                              />
                            </td>
                            <td>
                              <QtyInputPlusMinus
                                defaultValue={values.item.subExtraQuantity}
                                measurementType={values.item.product.measurementType}
                                subMeasurementType={values.item.product.subMeasurementType}
                                conversionUnit={values.item.product.conversionUnit}
                                onChange={(val, subVal) => {
                                  setFieldValue(`item[subExtraQuantity]`, subVal)
                                  setFieldValue(`item[extraQuantity]`, val)
                                }}
                              />
                            </td>

                            <td>
                              <div>
                                <QtyInput
                                  disabled={values.item.product.conversionUnit}
                                  className="text-input"
                                  measurementType={values.item.product.measurementType}
                                  subMeasurementType={values.item.product.subMeasurementType}
                                  conversionUnit={values.item.product.conversionUnit}
                                  onChange={(val, subVal) => {
                                    setFieldValue(`item[subWaste]`, subVal)
                                    setFieldValue(`item[waste]`, val)
                                  }}

                                  value={values.item.waste}
                                />
                                <ErrorMessage component={ErrorPopUp} name={`item.waste`} style={{ margin: '0 auto' }} />
                              </div>
                            </td>

                            <td>
                              <div>
                                <QtyInput
                                  disabled={values.item.product.conversionUnit}
                                  className="text-input"
                                  measurementType={values.item.product.measurementType}
                                  subMeasurementType={values.item.product.subMeasurementType}
                                  conversionUnit={values.item.product.conversionUnit}
                                  onChange={(val, subVal) => {
                                    setFieldValue(`item[subRemaining]`, subVal)
                                    setFieldValue(`item[remaining]`, val)
                                  }}

                                  value={values.item.remaining}
                                />
                                <ErrorMessage component={ErrorPopUp} name={`item.remaining`} style={{ margin: '0 auto' }} />
                              </div>
                            </td> */}
                          </tr>
                        </tbody>
                      </table>
                    </fieldset>
                  )}

                  {values && values.newItem && (
                    <fieldset className="fieldset">
                      <legend>کالای جایگزین</legend>

                      <table className="table validator-table">
                        <thead>
                          <tr>
                            <th className="text-center">برند</th>
                            <th className="text-center">کالا</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              <AsyncBrandSelect
                                clearable
                                className="semantic-select-box"
                                brandType={0}
                                defaultValue={values.newItem.brandId}
                                onChange={val => {
                                  setFieldValue(`newItem[brandId]`, val)
                                  // setFieldValue(`newItem[productId]`, '')
                                }}
                              />
                              <ErrorMessage
                                component={ErrorPopUp}
                                name={`newItem.brandId`}
                                type="select"
                              />
                            </td>
                            <td>
                              <AsyncProductSelect
                                clearable
                                className="semantic-select-box"
                                brandId={values.newItem.brandId}
                                categoryId={
                                  values.item &&
                                  values.item.product &&
                                  values.item.product.categoryId
                                }
                                // defaultValue={values.newItem.productId}
                                onChange={val => {
                                  setFieldValue(
                                    `newItem[productId]`,
                                    val ? val.value : ''
                                  )
                                  setFieldValue(
                                    `newItem[product]`,
                                    val ? val : ''
                                  )
                                  setFieldValue(
                                    `newItem[unitProductQuantity]`,
                                    val ? val.quantity : ''
                                  )
                                }}
                              />
                              <ErrorMessage
                                component={ErrorPopUp}
                                name={`newItem.productId`}
                                type="select"
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </fieldset>
                  )}

                  <fieldset className="fieldset">
                    <legend>توضیحات</legend>
                    <Field
                      name="description"
                      rows="2"
                      render={({ field }) => (
                        <textarea
                          {...field}
                          value={values.description || ''}
                          className="textarea rtl"
                        />
                      )}
                    />
                  </fieldset>

                  <button
                    type="submit"
                    style={{ marginBottom: 20 }}
                    className={
                      'icon button submit-btn ' +
                      (isSubmitting ? 'isSubmitting' : '')
                    }
                    disabled={isSubmitting || !values.newItem.productId}
                    onClick={() =>
                      validateForm().then(errors => {
                        console.log(errors)
                        // this.validateForm(errors);
                      })
                    }>
                    {isSubmitting ? (
                      <AiOutlineLoading className="mdi-spin" size="22px" />
                    ) : (
                      <AiOutlineSave size="22px" />
                    )}
                    ذخیره
                  </button>

                  {/* {JSON.stringify(values)} */}
                </form>
              </div>
              {this.state.loading ? <Loading /> : ''}
            </div>
          )
        }}
      </Formik>
    )
  }
}

export default ChangeProductsForm
